import { useTranslation } from 'react-i18next';
import { tv } from 'tailwind-variants';
import { Button, Loader } from '@/shared/components';
import { useNavigate } from 'react-router-dom';
import { useRandomCoin } from '../model';
import { useAppSettingsStore } from '@/shared/lib';

const classes = tv({
  slots: {
    container:
      'flex flex-col justify-between items-center min-h-screen w-full px-[2.4rem] md:px-[4.2rem] pt-[4.2rem] pb-[3rem] md:pb-[3.6rem]',
    logoContainer: 'flex justify-center w-full',
    logo: 'w-[13.6rem] h-auto',
    content:
      'flex flex-col items-center justify-center text-center w-[36rem] md:w-[58rem]',
    numberDisplay: 'flex items-center gap-x-[1.8rem] mb-[3.6rem]',
    number:
      'text-primary text-[9.6rem] md:text-[12rem] font-bold leading-[7.8rem] md:leading-[9.2rem]',
    coinContainer: 'relative',
    coinImage: 'w-[7.8rem] md:w-[9.2rem] h-[7.8rem] md:h-[9.2rem]',
    coinAsterisk:
      'absolute top-[-0.4rem] right-[-0.3rem] text-primary text-[1.6rem] font-bold',
    title: 'hero5 text-primary mb-2',
    description: 'p3 text-secondary mb-[3.6rem] px-[1.3rem] md:px-[8rem]',
    button: 'headline4 w-[23.3rem] h-[5.6rem] rounded-[1.2rem]',
    footer:
      'flex flex-col md:flex-row items-center justify-center text-center md:gap-x-[0.4rem]',
    footerText: 'p3 text-secondary',
    loaderContainer: 'flex items-center justify-center h-screen',
  },
});

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { baseAsset } = useAppSettingsStore();

  const c = classes();

  const { coin, icon, price, isLoading } = useRandomCoin(baseAsset);

  if (isLoading) {
    return (
      <div className={c.loaderContainer()}>
        <Loader />
      </div>
    );
  }

  const handleClick = () => navigate('/');

  const isCoinPriceVisible = Boolean(coin && icon && price && baseAsset);

  return (
    <div className={c.container()}>
      <div className={c.logoContainer()}>
        <img src="/assets/f2ex-logo.svg" alt="F2EX logo" className={c.logo()} />
      </div>

      <div className={c.content()}>
        <div className={c.numberDisplay()}>
          <span className={c.number()}>4</span>

          {icon ? (
            <div className={c.coinContainer()}>
              <img
                src={icon}
                alt={coin ? `${coin} icon` : 'Cryptocurrency icon'}
                className={c.coinImage()}
              />
              {price ? <span className={c.coinAsterisk()}>*</span> : null}
            </div>
          ) : (
            <span className={c.number()}>0</span>
          )}

          <span className={c.number()}>4</span>
        </div>

        <p className={c.title()}>{t('notFoundPage.title')}</p>

        <p className={c.description()}>{t('notFoundPage.description')}</p>

        <Button className={c.button()} onClick={handleClick}>
          {t('notFoundPage.buttonText')}
        </Button>
      </div>

      <div className={c.footer()}>
        {isCoinPriceVisible ? (
          <span className={c.footerText()}>
            *{coin}. 1 {coin} = {price} {baseAsset}
          </span>
        ) : null}
      </div>
    </div>
  );
};
